import { css } from 'styled-components';

export const transitions = css`
  .transitionGroup {
    /*overflow: hidden;*/
  }

  .forward .slide-enter {
    transform: translateX(100%);
  }

  .forward .slide-enter.slide-enter-active {
    transform: translateX(0);
    transition: transform 1.5s ease-in-out;
  }

  .forward .slide-exit {
    transform: translateX(-100%);
  }

  .forward .slide-exit.slide-exit-active {
    transform: translateX(-200%);
    transition: transform 1.5s ease-in-out;
  }

  .backward .slide-enter {
    transform: translateX(-100%);
  }

  .backward .slide-enter.slide-enter-active {
    transform: translateX(0);
    transition: transform 1.5s ease-in-out;
  }

  .backward .slide-exit {
    transform: translateX(-100%);
  }

  .backward .slide-exit.slide-exit-active {
    transform: translateX(0);
    transition: transform 1.5s ease-in-out;
  }

  .gallery.forward .slide-enter {
    transform: translateX(100%);
  }

  .gallery.forward .slide-enter.slide-enter-active {
    transform: translateX(0);
    transition: transform 0.7s ease-in-out;
  }

  .gallery.forward .slide-exit {
    transform: translateX(-100%);
  }

  .gallery.forward .slide-exit.slide-exit-active {
    transform: translateX(-200%);
    transition: transform 0.7s ease-in-out;
  }

  .gallery.backward .slide-enter {
    transform: translateX(-100%);
  }

  .gallery.backward .slide-enter.slide-enter-active {
    transform: translateX(0);
    transition: transform 0.7s ease-in-out;
  }

  .gallery.backward .slide-exit {
    transform: translateX(-100%);
  }

  .gallery.backward .slide-exit.slide-exit-active {
    transform: translateX(0);
    transition: transform 0.7s ease-in-out;
  }
`;
